export interface Product {
  id: number;
  product: string;
  sku: string;
  price: number;
  cost: number;
  sales: number;
  stock: number;
  rating: number;
  status: 'in_stock' | 'out_of_stock' | 'restocking';
  model: string;
  totalSold: number;
  incoming: number;
  colors: string[];
  image: string;
}

// TODO: replace data with something else? More realistic? Just using this one for visualizing - also images are random (and some not free)

export const products: Product[] = [
  {
    id: 1,
    product: 'Sony Alpha A7 IV',
    sku: 'SON-A7IV',
    price: 2400,
    cost: 1800,
    sales: 13,
    stock: 15,
    rating: 4.8,
    status: 'in_stock',
    model: 'ILCE-7M4',
    totalSold: 250,
    incoming: 30,
    colors: ['Black', 'Silver'],
    image:
      'https://images.pexels.com/photos/1983037/pexels-photo-1983037.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 2,
    product: 'Dell XPS 15',
    sku: 'DEL-XPS15',
    price: 1599,
    cost: 1200,
    sales: 48,
    stock: 8,
    rating: 4.3,
    status: 'restocking',
    model: 'XPS 15 9520',
    totalSold: 180,
    incoming: 25,
    colors: ['Platinum Silver', 'Frost White'],
    image:
      'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 3,
    product: 'Samsung Odyssey G9',
    sku: 'SAM-ODG9',
    price: 1299,
    cost: 950,
    sales: 52,
    stock: 0,
    rating: 4.1,
    status: 'out_of_stock',
    model: 'LC49G95TSSNXZA',
    totalSold: 120,
    incoming: 15,
    colors: ['Black'],
    image:
      'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 4,
    product: 'Blue Yeti X',
    sku: 'BLU-YETIX',
    price: 149,
    cost: 110,
    sales: 21,
    stock: 25,
    rating: 4.6,
    status: 'in_stock',
    model: 'YETIX',
    totalSold: 300,
    incoming: 40,
    colors: ['Black', 'White', 'Blue'],
    image:
      'https://images.pexels.com/photos/1054713/pexels-photo-1054713.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 5,
    product: 'Sony WH-1000XM5',
    sku: 'SON-WH1000XM5',
    price: 399,
    cost: 280,
    sales: 17,
    stock: 12,
    rating: 4.9,
    status: 'in_stock',
    model: 'WH-1000XM5',
    totalSold: 400,
    incoming: 50,
    colors: ['Black', 'Silver'],
    image:
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 6,
    product: 'Apple MacBook Pro 14',
    sku: 'APP-MBP14',
    price: 1999,
    cost: 1450,
    sales: 95,
    stock: 8,
    rating: 4.7,
    status: 'in_stock',
    model: 'A2442',
    totalSold: 474,
    incoming: 24,
    colors: ['Space Gray', 'Silver'],
    image:
      'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 7,
    product: 'Elgato Stream Deck MK.2',
    sku: 'ELG-SDMK2',
    price: 149,
    cost: 95,
    sales: 38,
    stock: 1,
    rating: 4.5,
    status: 'restocking',
    model: '10GAT9901',
    totalSold: 423,
    incoming: 32,
    colors: ['Black'],
    image: 'https://m.media-amazon.com/images/I/81xN-mI5KBL.jpg@._V1_QL100_UY120_CR0,,120,120.jpg',
  },
  {
    id: 8,
    product: 'Logitech MX Master 3S',
    sku: 'LOG-MXM3S',
    price: 99,
    cost: 60,
    sales: 79,
    stock: 14,
    rating: 4.8,
    status: 'in_stock',
    model: '910-006556',
    totalSold: 320,
    incoming: 20,
    colors: ['Graphite', 'Pale Gray'],
    image:
      'https://images.pexels.com/photos/392018/pexels-photo-392018.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 9,
    product: 'Canon EOS R6 Mark II',
    sku: 'CAN-EOSR6M2',
    price: 2499,
    cost: 1800,
    sales: 14,
    stock: 15,
    rating: 4.3,
    status: 'out_of_stock',
    model: '4082C002',
    totalSold: 466,
    incoming: 12,
    colors: ['Black'],
    image:
      'https://images.pexels.com/photos/1983037/pexels-photo-1983037.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 10,
    product: 'Razer Seiren Mini',
    sku: 'RAZ-SMINI',
    price: 49,
    cost: 25,
    sales: 11,
    stock: 30,
    rating: 4.9,
    status: 'in_stock',
    model: 'RZ19-03450100-R3U1',
    totalSold: 174,
    incoming: 54,
    colors: ['Black', 'White', 'Pink'],
    image:
      'https://images.pexels.com/photos/1054713/pexels-photo-1054713.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 11,
    product: 'Anker USB-C Hub 7-in-1',
    sku: 'ANK-7IN1',
    price: 69,
    cost: 40,
    sales: 58,
    stock: 20,
    rating: 4.6,
    status: 'in_stock',
    model: 'A83460A2',
    totalSold: 305,
    incoming: 18,
    colors: ['Gray'],
    image:
      'https://images.pexels.com/photos/30708285/pexels-photo-30708285.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 12,
    product: 'LG UltraFine 5K Monitor',
    sku: 'LG-UF5K',
    price: 1299,
    cost: 1000,
    sales: 22,
    stock: 4,
    rating: 4.4,
    status: 'restocking',
    model: '27MD5KL-B',
    totalSold: 195,
    incoming: 10,
    colors: ['Black'],
    image:
      'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 13,
    product: 'Shure SM7B Microphone',
    sku: 'SHU-SM7B',
    price: 399,
    cost: 280,
    sales: 11,
    stock: 12,
    rating: 4.9,
    status: 'in_stock',
    model: 'SM7B',
    totalSold: 412,
    incoming: 30,
    colors: ['Black'],
    image:
      'https://images.pexels.com/photos/1054713/pexels-photo-1054713.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 14,
    product: 'DJI Osmo Pocket 3',
    sku: 'DJI-OSP3',
    price: 519,
    cost: 390,
    sales: 38,
    stock: 9,
    rating: 4.7,
    status: 'in_stock',
    model: 'Osmo Pocket 3',
    totalSold: 240,
    incoming: 16,
    colors: ['Black'],
    image:
      'https://images.pexels.com/photos/1983037/pexels-photo-1983037.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 15,
    product: 'Logitech Brio 4K Webcam',
    sku: 'LOG-BRIO4K',
    price: 199,
    cost: 120,
    sales: 46,
    stock: 11,
    rating: 4.5,
    status: 'in_stock',
    model: '960-001105',
    totalSold: 375,
    incoming: 22,
    colors: ['Black'],
    image:
      'https://images.unsplash.com/photo-1614588876378-b2ffa4520c22??w=120&h=120&fit=crop&q=100',
  },
  {
    id: 16,
    product: 'Rode Wireless GO II',
    sku: 'ROD-WGO2',
    price: 299,
    cost: 210,
    sales: 44,
    stock: 7,
    rating: 4.6,
    status: 'restocking',
    model: 'WIGOII',
    totalSold: 310,
    incoming: 20,
    colors: ['Black'],
    image:
      'https://images.pexels.com/photos/1054713/pexels-photo-1054713.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 17,
    product: 'BenQ PD3220U Monitor',
    sku: 'BNQ-PD3220U',
    price: 1099,
    cost: 820,
    sales: 19,
    stock: 3,
    rating: 4.7,
    status: 'out_of_stock',
    model: 'PD3220U',
    totalSold: 165,
    incoming: 8,
    colors: ['Black'],
    image:
      'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 18,
    product: 'Google Nest Wifi Pro',
    sku: 'GOO-NESTWIFI',
    price: 199,
    cost: 150,
    sales: 13,
    stock: 10,
    rating: 4.3,
    status: 'in_stock',
    model: 'G6ZUC',
    totalSold: 214,
    incoming: 12,
    colors: ['White', 'Fog', 'Linen'],
    image:
      'https://georgiapowermarketplace.com/dw/image/v2/BDDP_PRD/on/demandware.static/-/Sites-masterCatalog/default/dw4a7b3d7f/Products/I-GOOWIFPRO-01-SNOW-XXXX-V1.jpg?sw=120&sh=120',
  },
  {
    id: 19,
    product: 'Apple iPad Pro 11"',
    sku: 'APP-IPADPRO11',
    price: 899,
    cost: 720,
    sales: 41,
    stock: 5,
    rating: 4.8,
    status: 'restocking',
    model: 'M4',
    totalSold: 282,
    incoming: 18,
    colors: ['Space Gray', 'Silver'],
    image:
      'https://images.pexels.com/photos/2351844/pexels-photo-2351844.jpeg?w=120&h=120&fit=crop&q=100',
  },
  {
    id: 20,
    product: 'Aputure Amaran 200x',
    sku: 'APU-200X',
    price: 349,
    cost: 250,
    sales: 20,
    stock: 6,
    rating: 4.5,
    status: 'in_stock',
    model: 'Amaran 200x',
    totalSold: 140,
    incoming: 10,
    colors: ['Black'],
    image: 'https://m.media-amazon.com/images/I/6120ERqr3xL._UF120,120_QL100_.jpg',
  },
];
